import { render, staticRenderFns } from "./PerformDashTitle.vue?vue&type=template&id=44ca426e&scoped=true&"
import script from "./PerformDashTitle.vue?vue&type=script&lang=js&"
export * from "./PerformDashTitle.vue?vue&type=script&lang=js&"
import style0 from "./PerformDashTitle.vue?vue&type=style&index=0&id=44ca426e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca426e",
  null
  
)

export default component.exports